<template>
  <section class="text-img-component">
    <div class="text-img-component__grid-container"
         :class="[position, color]">
      <div class="text-img-component__text-container">
        <h2 class="text-img-component__headline">  {{ blockContent.headline }} </h2>
        <p class="text-img-component__paragraph" v-html="blockContent.paragraph"></p>
        <Button :buttonContent="buttonContent"/>
      </div>
    <div class="text-img-component__img-container"
         :class="bgImg">
    </div>
    </div>
  </section>
</template>

<script>
import Button from './Button'

export default {
  name: 'TextImgComponent',
  components: {
    Button
  },
  props: {
    blockContent: {
      type: Object,
      default: function () {
        return {
          headline: 'TROCHĘ HISTORII',
          paragraph: 'Historia firmy zaczęła się w czerwcu 2013 roku. Na początku zatrudnialiśmy 30 osób odpowiedzialnych za produkcję i logistykę. W 2015 zatrudnienie wzrosło do 70 osób. W 2018 zatrudnialiśmy już 140 osób. Ten poziom zatrudnienia uznaliśmy za optymalny. Dziś zatrudniamy ponad 150 osób.',
        }
      }
    },
    position: {
      type: String,
      default: "'text-area img-area'"
    },
    color: {
      type: String,
      default: "'text-img-component--grid-grey'"
    },
    bgImg: {
      type: String,
      default: "'text-img-component--img1'"
    },
    buttonContent: {
      type: Object,
      default: function () {
        return {
          url: '#',
          label: 'DOWIEDZ SIĘ WIECEJ',
        }
      }
    }
  }
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
